// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__3RFc_","searchIcon":"SearchBox_searchIcon__1D7yw","inputWidth":"SearchBox_inputWidth__3LOR0"};